/** Shown for a proposal whose block changed, and for a failed Accept: the reason itself is developer text */
export const staleProposalMessage = 'This block changed — the suggestion no longer applies.'
